import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-no-results-found',
  templateUrl: './no-results-found.component.html',
  styleUrls: ['./no-results-found.component.css']
})
export class NoResultsFoundComponent implements OnInit {
  @Input() title: string
  @Input() hide: string
  @Input() route: string

  constructor() { }

  ngOnInit(): void {

  }

}
